var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('home',{on:{"start":_vm.startQuestion}}),_c('page-wrap',{attrs:{"title":"户口迁移查询"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }